import {useState, useEffect, useMemo} from 'react';
import {SCREEN_SIZE} from '../../constants';

interface WindowSize {
    width: number | undefined;
    height: number | undefined;
    viewportHeight: number | undefined;
    isDefined: boolean;
}

export default function useWindowSize() {
    const [windowSize, setWindowSize] = useState<WindowSize>({
        width: undefined,
        height: undefined,
        viewportHeight: undefined,
        isDefined: false
    });
    const isMobile = windowSize.width !== undefined && windowSize.width <= SCREEN_SIZE.SM;

    function handleResize() {
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
            viewportHeight: window.visualViewport?.height,
            isDefined: true
        });
    }

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        window.visualViewport?.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
            window.visualViewport?.removeEventListener('resize', handleResize);
        };
    }, []);

    return useMemo(() => ({
        isMobile,
        ...windowSize
    }), [isMobile, windowSize.width, windowSize.height, windowSize.viewportHeight, windowSize.isDefined]);
}
